<template>
  <div>
    <Notificacao class="padding-alerta" tipo="alerta" :texto="alinharAlertas" />
  </div>
</template>

<script>
import Notificacao from "@/components/Notificacao/Notificacao.vue";

export default {
  name: "AlertaInstrucaoNormativa",
  props: {
    alinharAlertas: String
  },
  components: { Notificacao }
};
</script>

<style lang="scss" scoped>
.padding-alerta {
  margin-left: 22px;
  margin-top: 0px;
  &:last-child {
    margin-bottom: 0px;
  }
}
</style>
